"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loopWithFuse = exports.applyAutomaticMoves = void 0;
function applyAutomaticMoves(game) {
    loopWithFuse(function () {
        var move = game.getAutomaticMove ? game.getAutomaticMove() : undefined;
        if (move) {
            game.play(JSON.parse(JSON.stringify(move)));
        }
        return move != undefined;
    }, { errorFn: function () { return new Error("Infinite loop detected while applying automatic moves in " + JSON.stringify(game.state)); } });
}
exports.applyAutomaticMoves = applyAutomaticMoves;
function loopWithFuse(repeat, options) {
    var attempts = (options === null || options === void 0 ? void 0 : options.attempts) || (process.env.NODE_ENV === 'development' ? 100 : 1000);
    var errorFn = (options === null || options === void 0 ? void 0 : options.errorFn) || (function () { return new Error('Infinite loop detected'); });
    while (repeat()) {
        if (attempts == 0) {
            throw errorFn();
        }
        attempts--;
    }
}
exports.loopWithFuse = loopWithFuse;
//# sourceMappingURL=Game.js.map